import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import { type ChildRouteContext } from "@/root";

import TagsList from "@/modules/performance/admin/components/tags/TagList";

export const Route = createFileRoute(
  "/admin/_panel/_performance/performance/tags/",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Manage Tags", { ns: "performance.admin" }),
        },
      ],
    }) satisfies ChildRouteContext,
});

function RouteComponent() {
  const { t } = useTranslation("performance.admin");
  return (
    <Container
      title={t("Manage Tags")}
      description={t("Manage, create and edit tags", {
        ns: "performance.admin",
      })}
    >
      <TagsList />
    </Container>
  );
}
